import { mx } from "@springcare/dsm";
export var fonts = {
    body: "Hanken Grotesk, sans-serif",
    heading: "Hanken Grotesk, sans-serif",
};
export var fontSizes = mx.fontSizes;
export var lineHeights = mx.lineHeights;
export var fontWeights = mx.fontWeights;
